import type { PaymentMethod } from "@stripe/stripe-js";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { t } from "ttag";

import {
  billingQueriesStore,
  updatePaymentMethod,
} from "@/features/billing/api";
import { errorToast } from "@/shared/ui";

export const useUpdatePaymentMethod = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (paymentMethodId: PaymentMethod["id"]) =>
      updatePaymentMethod(paymentMethodId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: billingQueriesStore.payments.queryKey,
      });
      void queryClient.invalidateQueries({
        queryKey: billingQueriesStore.subscriptions.queryKey,
      });
    },
    onError: () => {
      errorToast(
        t`Error updating payment method, try again later or use a different card.`,
      );
    },
  });
};
